var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReviewMenuWithLabels',{attrs:{"link_to":"/training-grade-reviews/","title":"Training Grade reviews"}})}
var staticRenderFns = []

export { render, staticRenderFns }